module.exports = __webpack_public_path__ + "static/media/220-Auf-Milo-Warten_ID_1.61a52034.mp3";